<template>
  <div>
    <!-- <div style="word-break: break-all; white-space: pre-wrap;">{{Modal}}</div> -->
    <component
      :is="componentName"
      :ref="componentName + '1'"
      :info="info.config"
      :commmonType="type"
      :index="index"
      @close="close"
      @add="add"
      @closeModel="$emit('closeModel', $event)"
      @changeModal="changeModal($event)"
      v-model="Modal"
    ></component>
  </div>
</template>

<script>
import customVideo1 from "@components/custom-component/common/custom-video/components/custom-video-type-1.vue";
export default {
  // 视频类型 1
  name: "custom-video",
  model: {
    prop: "Modal",
    event: "sendModal"
  },
  props: {
    Modal: {
      type: Object,
      default: function() {
        return {
          type: 1, // 视频类型 暂时只有 1
          cover: "", // 封面
          time: 5000, // 视频封面截取帧
          link: "", // 视频地址
          coverType: "0" // 视频封面累心 0 截取 1 自定义 
        };
      }
    },
    index: {
      type: Number,
      default: 0
    },
    info: {
      type: Object,
      default: {
        title: "视频",
        icon: "icon-shangchuanshipin",
        type: "video",
        componentName: "customVideo",
        config: {
          type: 1, // 视频类型 暂时只有 1
          cover: "", // 封面
          time: 5000, // 视频封面截取帧
          link: "", // 视频地址
          coverType: "0" // 视频封面累心 0 截取 1 自定义
        }
      }
    }, 
    type: { // 通用添加组件的列表   1：所有列表   2：筛选列表
      type: Number,
      default: 1,
    }
  },
  computed: {
    componentName() {
      return `customVideo${this.info.config.type}`;
    }
  },
  data() {
    return {};
  },
  components: {
    customVideo1
  },
  methods: {
    close() {
      this.$emit("close");
    },
    add(item, idx) {
      this.$emit("add", item, idx);
    },
    hide(bool) { 
      this.$refs[this.componentName + "1"].visible = bool;
    },
    changeModal(e) {
      this.$emit("sendModal", e);  
    }
  }
};
</script>

<style scoped lang="scss">
</style>
